import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Fade,
} from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import PeopleIcon from '@mui/icons-material/People';
import QuizIcon from '@mui/icons-material/Quiz';
import ArticleIcon from '@mui/icons-material/Article';
import { useAppSelector } from '../../store/hooks';

const StatisticsSection: React.FC = () => {
  const { courses } = useAppSelector((state) => state.courses);
  const { blogs } = useAppSelector((state) => state.blogs);

  const stats = [
    {
      icon: <SchoolIcon sx={{ fontSize: 48 }} />,
      value: courses.length || 0,
      label: 'Courses',
      color: 'primary.main',
    },
    {
      icon: <PeopleIcon sx={{ fontSize: 48 }} />,
      value: '10K+',
      label: 'Active Learners',
      color: 'secondary.main',
    },
    {
      icon: <QuizIcon sx={{ fontSize: 48 }} />,
      value: courses.length || 0,
      label: 'Available Quizzes',
      color: 'info.main',
    },
    {
      icon: <ArticleIcon sx={{ fontSize: 48 }} />,
      value: blogs.length || 0,
      label: 'Blog Posts',
      color: 'success.main',
    },
  ];

  return (
    <Box
      sx={{
        background: 'linear-gradient(180deg, rgba(10, 15, 25, 1) 0%, rgba(0, 0, 0, 1) 100%)',
        py: { xs: 8, md: 12 },
        position: 'relative',
      }}
    >
      <Container maxWidth="lg">
      <Fade in timeout={1400}>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography
            variant="h3"
            component="h2"
            sx={{ mb: 2, fontWeight: 700 }}
          >
            Platform Statistics
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '600px', mx: 'auto' }}>
            Join thousands of learners on their journey to success
          </Typography>
        </Box>
      </Fade>
      <Grid container spacing={4}>
        {stats.map((stat, index) => (
          <Grid item xs={6} md={3} key={index}>
            <Fade in timeout={1600 + index * 200}>
              <Box
                sx={{
                  textAlign: 'center',
                  p: 4,
                  borderRadius: 3,
                  background: 'linear-gradient(135deg, rgba(30, 41, 59, 0.6) 0%, rgba(15, 23, 42, 0.8) 100%)',
                  border: '1px solid rgba(148, 163, 184, 0.1)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    borderColor: `rgba(${stat.color === 'primary.main' ? '99, 102, 241' : stat.color === 'secondary.main' ? '236, 72, 153' : stat.color === 'info.main' ? '59, 130, 246' : '16, 185, 129'}, 0.3)`,
                    boxShadow: `0 20px 40px rgba(${stat.color === 'primary.main' ? '99, 102, 241' : stat.color === 'secondary.main' ? '236, 72, 153' : stat.color === 'info.main' ? '59, 130, 246' : '16, 185, 129'}, 0.2)`,
                  },
                }}
              >
                <Box
                  sx={{
                    display: 'inline-flex',
                    p: 2,
                    borderRadius: 3,
                    background: `linear-gradient(135deg, rgba(${stat.color === 'primary.main' ? '99, 102, 241' : stat.color === 'secondary.main' ? '236, 72, 153' : stat.color === 'info.main' ? '59, 130, 246' : '16, 185, 129'}, 0.2) 0%, rgba(${stat.color === 'primary.main' ? '139, 92, 246' : stat.color === 'secondary.main' ? '219, 39, 119' : stat.color === 'info.main' ? '37, 99, 235' : '5, 150, 105'}, 0.2) 100%)`,
                    mb: 3,
                    color: stat.color,
                  }}
                >
                  {stat.icon}
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    mb: 1,
                    fontWeight: 700,
                    background: `linear-gradient(135deg, ${stat.color === 'primary.main' ? '#6366f1' : stat.color === 'secondary.main' ? '#ec4899' : stat.color === 'info.main' ? '#3b82f6' : '#10b981'} 0%, ${stat.color === 'primary.main' ? '#8b5cf6' : stat.color === 'secondary.main' ? '#db2777' : stat.color === 'info.main' ? '#2563eb' : '#059669'} 100%)`,
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  {stat.value}
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ fontWeight: 500 }}>
                  {stat.label}
                </Typography>
              </Box>
            </Fade>
          </Grid>
        ))}
      </Grid>
      </Container>
    </Box>
  );
};

export default StatisticsSection;

